import {Person_person_openApplications_SlideApplication} from 'graphql/deserializedTypes/Person'
import {isUnder18} from 'utils/age'

export type SlideApplication = Omit<
  Person_person_openApplications_SlideApplication,
  'eligibilityDeterminations' | 'person'
>

export type SlideApplicationWithInitialDateOfService = SlideApplication & {
  initialDateOfService: Date
}

export const isMinorCharityCare = (
  {
    dob,
    isStudent,
  }: {
    dob: Date | null
    isStudent: boolean | null
  },
  {
    livesWithParents,
  }: {
    livesWithParents: boolean
  }
) => dob && (isUnder18(dob) || (isStudent && livesWithParents))

export const isSlideApplicationWithInitialDateOfService = (
  application: SlideApplication
): application is SlideApplicationWithInitialDateOfService =>
  !!application.initialDateOfService
